export type AppConfig = {
    apiUrl: string
    workerVersion: string
    azureAdClientId: string
    azureAdTenantId: string
    azureAdRedirectUrl: string
    azureAuthorityBaseUrl: string
}

export const getAppConfig = (): AppConfig => {
    const env = (window as any).env

    return {
        apiUrl: env.apiUrl,
        workerVersion: env.workerVersion,
        azureAdClientId: env.azureAdClientId,
        azureAdTenantId: env.azureAdTenantId,
        azureAdRedirectUrl: env.azureAdRedirectUrl,
        azureAuthorityBaseUrl: env.azureAuthorityBaseUrl,
    }
}

export const isDebug = () => process.env.NODE_ENV === 'development'
